export const GA_UA = "UA-178502719-3";